module.exports = __webpack_public_path__ + "img/9f6650f8a0eb4b9f93519d1b61a67cdd.575941b5.png";